// externals
import type { Reducer } from 'redux';

// types
import type { VehicleDetailsState } from '../types';

// store
import { vehicleDetailsInitialState } from './initialState';

// actions
import {
    FETCH_VEHICLE_DETAILS_REQUEST,
    FETCH_VEHICLE_DETAILS_SUCCESS,
    FETCH_VEHICLE_DETAILS_FAILURE,
    BUY_THIS_VEHICLE,
    FETCH_DEAL_SUCCESS
} from './actions';

export type VehicleDetailsReducer = Reducer<VehicleDetailsState>;

export const vehicleDetailsReducer: VehicleDetailsReducer = (state = vehicleDetailsInitialState, action: any) => {
    switch (action.type) {
        case FETCH_VEHICLE_DETAILS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case FETCH_VEHICLE_DETAILS_SUCCESS: {
            return {
                ...vehicleDetailsInitialState,
                ...action.payload?.vehicle,
                isLoading: false,
                error: null
            };
        }

        case FETCH_VEHICLE_DETAILS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload?.message || 'Failed to fetch vehicle details'
            };

        case BUY_THIS_VEHICLE:
        case FETCH_DEAL_SUCCESS:
            return vehicleDetailsInitialState;

        default:
            return state;
    }
};
